import './App.css';
import {Navigate, Route, Routes} from "react-router-dom";
import Layout from "./components/Layout";
import Categories from "./components/Categories";
import CategoryForms from "./pages/CategoryForms";
import NotFound from "./pages/NotFound";
import FormView from "./pages/FormView";
import { useEffect,useState } from 'react';
import SelectBranch from './components/Branches';

function App() {
    
   
    return (
        <div className="w-[100vw] h-[100vh] pb-20 layout text-gray-700">
            <Routes>
                <Route path="/" element={<Layout/>}>
               
                 <Route index element={<Navigate to='branches'/>}/> 
                   <Route path="branches" element={<SelectBranch />} />
                    <Route path={'categories'} element={<Categories/>}/>
                    <Route path={'forms'}>
                        <Route path={':categoryId'} element={<CategoryForms/>}/>
                        <Route path={':formId/fields'} element={<FormView/>}/>
                    </Route>
                    <Route path={'*'} element={<NotFound/>}/>
                </Route>
            </Routes>
        </div>
    );
}

export default App;
